import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';

const SignatureDialog = ({ open, onClose, onSave, onClear, signaturePadRef }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: '#008080', fontWeight: 'bold' }}>Provide Your Signature</DialogTitle>
      <DialogContent sx={{ p: 4, display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ border: '2px solid #008080', borderRadius: 2, overflow: 'hidden', backgroundColor: '#fff' }}>
          <SignatureCanvas
            ref={signaturePadRef}
            canvasProps={{ width: 450, height: 200, className: "sigCanvas" }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button onClick={onClose} variant="outlined" color="primary">Cancel</Button>
        <Button onClick={onClear} variant="outlined" color="secondary">Clear</Button>
        <Button onClick={onSave} variant="contained" color="primary" sx={{ px: 4 }}>Done</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignatureDialog;
